var map = {
	"./Coilcraft_logo.gif": 77,
	"./Vicor.png": 78,
	"./akoustis.png": 79,
	"./congatec.jpg": 80,
	"./cp_logo.jpg": 81,
	"./dcl_tek.webp": 82,
	"./elo.png": 83,
	"./everlight.svg": 84,
	"./knowles.jpg": 85,
	"./methode.jpg": 86,
	"./microchip.jpg": 87,
	"./nexperia.jpg": 88,
	"./nexperia.png": 89
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76;